import { CloseOutlined, MenuOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import cn from 'classnames';

import { PF } from '@app/components/RecordModal/data/constants';
import { useSidebar } from '@app/components/RecordModal/hooks';
import {
  MenuTabEnum,
  type SidebarProps,
} from '@app/components/RecordModal/types';

import type { FC } from 'react';

export const Sidebar: FC<SidebarProps> = ({ tab, onSelectTab, disabled }) => {
  const {
    menuItems,
    isSidebarOpen,
    toggleSidebar,
    closeSidebar,
    currentTabLabel,
  } = useSidebar(tab);

  return (
    <>
      <div className={`${PF}__mobile-header`}>
        <button
          type="button"
          className={`${PF}__sidebar-toggle`}
          onClick={toggleSidebar}
        >
          {isSidebarOpen ? <CloseOutlined /> : <MenuOutlined />}
        </button>
        <span className={`${PF}__mobile-header-title`}>{currentTabLabel}</span>
      </div>
      <div
        className={cn(`${PF}__sidebar-overlay`, {
          [`${PF}__sidebar-overlay--visible`]: isSidebarOpen,
        })}
        onClick={closeSidebar}
      />
      <div
        className={cn(`${PF}__sidebar`, {
          [`${PF}__sidebar--open`]: isSidebarOpen,
        })}
      >
        <Menu
          className={`${PF}__sidebar-menu`}
          items={menuItems}
          disabled={disabled}
          defaultSelectedKeys={[MenuTabEnum.RecordDetails]}
          selectedKeys={[tab]}
          onClick={({ key }) => {
            onSelectTab(key as MenuTabEnum);
            closeSidebar();
          }}
        />
      </div>
    </>
  );
};
